import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Table, PageHeader, Modal, FormField } from '../../components/UI';
import toast from 'react-hot-toast';

const empty = { menu_name:'', menu_code:'', menu_icon:'', menu_path:'', parent_id:'', sort_order:0, is_active:1 };

export default function MenuMaster() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);

  const load = () => { setLoading(true); api.get('/rbac/menus').then(r => setItems(r.menus||[])).finally(()=>setLoading(false)); };
  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm(empty); setEditing(null); setModal(true); };
  const openEdit = (item) => { setForm({...item, parent_id: item.parent_id||''}); setEditing(item); setModal(true); };
  const f = (k,v) => setForm(p=>({...p,[k]:v}));

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      if (editing) { await api.put(`/rbac/menus/${editing.id}`, form); toast.success('Menu updated'); }
      else { await api.post('/rbac/menus', form); toast.success('Menu created'); }
      setModal(false); load();
    } catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  const parentMenus = items.filter(m => !m.parent_id);

  const columns = [
    { key:'sort_order', label:'#', render: r => <span className="text-gray-400 text-xs">{r.sort_order}</span> },
    { key:'menu_name', label:'Menu Name', render: r => (
      <div>
        <span className={r.parent_id ? 'pl-4 text-gray-600' : 'font-semibold text-gray-800'}>
          {r.parent_id ? '↳ ' : ''}{r.menu_name}
        </span>
      </div>
    )},
    { key:'menu_code', label:'Code', render: r => <code className="text-xs bg-gray-100 px-2 py-0.5 rounded">{r.menu_code}</code> },
    { key:'menu_icon', label:'Icon', render: r => <span className="text-xs text-gray-500">{r.menu_icon}</span> },
    { key:'menu_path', label:'Path', render: r => <code className="text-xs text-blue-600">{r.menu_path}</code> },
    { key:'is_active', label:'Status', render: r => <span className={r.is_active ? 'text-green-600' : 'text-red-500'}>{r.is_active ? 'Active' : 'Inactive'}</span> },
    { key:'actions', label:'Actions', render: r => (
      <button onClick={() => openEdit(r)} className="text-xs bg-yellow-50 text-yellow-600 border border-yellow-200 px-2 py-1 rounded">✏️ Edit</button>
    )},
  ];

  return (
    <div>
      <PageHeader title="Menu Manager" subtitle="Configure system menus for RBAC"
        actions={<button className="btn-primary" onClick={openAdd}>+ Add Menu</button>} />

      <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-xl text-sm text-blue-700">
        ℹ️ Menus defined here are used in the RBAC Permission Matrix. Add parent menus first, then sub-menus.
      </div>

      <div className="card overflow-hidden p-0">
        <Table columns={columns} data={items} loading={loading} />
      </div>

      <Modal isOpen={modal} onClose={() => setModal(false)} title={editing ? 'Edit Menu' : 'Add Menu'} size="lg">
        <form onSubmit={handleSave} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <FormField label="Menu Name" required>
              <input className="form-input" value={form.menu_name} onChange={e=>f('menu_name',e.target.value)} required />
            </FormField>
            <FormField label="Menu Code" required>
              <input className="form-input" value={form.menu_code} onChange={e=>f('menu_code',e.target.value.toLowerCase().replace(/\s+/g,'_'))} required placeholder="e.g. admin_dashboard" />
            </FormField>
            <FormField label="Menu Path">
              <input className="form-input" value={form.menu_path} onChange={e=>f('menu_path',e.target.value)} placeholder="/admin/dashboard" />
            </FormField>
            <FormField label="Menu Icon">
              <input className="form-input" value={form.menu_icon} onChange={e=>f('menu_icon',e.target.value)} placeholder="e.g. LayoutDashboard" />
            </FormField>
            <FormField label="Parent Menu (leave blank for top-level)">
              <select className="form-select" value={form.parent_id} onChange={e=>f('parent_id',e.target.value)}>
                <option value="">No Parent (Top Level)</option>
                {parentMenus.map(m => <option key={m.id} value={m.id}>{m.menu_name}</option>)}
              </select>
            </FormField>
            <FormField label="Sort Order">
              <input type="number" className="form-input" value={form.sort_order} onChange={e=>f('sort_order',e.target.value)} />
            </FormField>
            <FormField label="Status">
              <select className="form-select" value={form.is_active} onChange={e=>f('is_active',e.target.value)}>
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </FormField>
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" className="btn-secondary" onClick={() => setModal(false)}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Save Menu'}</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}